import React from "react";
import { Link, withRouter } from "react-router-dom";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { Typography, Button, Icon } from "../../ecosystem/";

export function ECheckInCTA(props) {
    const { eCheckInStatus, eCheckinCompleted, isRequireEcheckin, csnIdOfAppointment, history, isMobile, appointmentDetails } = props;

    const EcheckInRoute = csnIdOfAppointment ? { pathname: "/EcheckIn", state: { csnId: csnIdOfAppointment } } : { pathname: "/appointments" };

    const patientExternalId = appointmentDetails && appointmentDetails.patientExternalId ? appointmentDetails.patientExternalId : ''; 


    const eCheckInClick = () => {
        logUI("MBHWeb.Dashboard.AppointmentTile.eCheckIn.Click", new Date(), Tools.getURLPath());
        csnIdOfAppointment ? history.push({ pathname: "/EcheckIn", state: { csnId: csnIdOfAppointment, Id: patientExternalId } }) : history.push({ pathname: "/appointments" })
    }

    return (
        <React.Fragment>
            {eCheckInStatus === 'Not Started' || eCheckInStatus === 'In Progress'
                ? <div className={"appt-tile__eCheckIn-btn"}>
                    <Button fluid={isMobile ? true : false} variant="secondary" onClick={eCheckInClick}>Begin eCheck-in</Button>
                    <div className="appt-tile__eCheckIn-msg">
                        {isRequireEcheckin && !eCheckinCompleted && <Typography type="meta-01" tag="div" textAlign="center" color="$color-secondary-a2" >*eCheck-In required to launch visit</Typography>}
                    </div>
                </div>
                : <React.Fragment>
                    {eCheckinCompleted &&
                        <div className={"appt-tile__eCheckIn-status"}>
                            <div className="eCheckIn-status--complete">
                                <Icon name="check" color="$color-system-a1" />
                                <Typography type="body-02"
                                    bold
                                    color={"$color-system-a1"}
                                >
                                    eCheck-in Completed
                                </Typography>
                            </div>
                        </div>
                    }
                </React.Fragment>
            }
        </React.Fragment>
    );
}

export default withRouter(ECheckInCTA);


